<template>
  <form class="cm-form" @submit.prevent>
    <div class="cm-hero">
      <img
        class="cm-hero-logo"
        src="https://cdn.platform.bostello.com/assets/bostello_mail_logo.webp"
        alt="Bostello"
        width="120"
        height="48"
        loading="eager"
        decoding="async"
      />
      <div class="cm-help">{{ t('contactForm.noSpam') }}</div>
    </div>

    <div class="cm-field" :class="{ 'cm-invalid': !!errors.email }">
      <label class="cm-label" for="cm-email">{{ t('contactForm.email') }}</label>
      <input
        class="cm-input"
        id="cm-email"
        name="email"
        type="email"
        autocomplete="email"
        :placeholder="t('contactForm.emailPlaceholder')"
        :value="model.email"
        @input="onInput('email', ($event.target as HTMLInputElement).value)"
      />
      <div class="cm-error">{{ errors.email }}</div>
    </div>

    <div class="cm-field" :class="{ 'cm-invalid': !!errors.acceptPrivacyPolicy }">
      <label class="cm-check">
        <input
          id="cm-privacy"
          name="acceptPrivacyPolicy"
          type="checkbox"
          :checked="model.acceptPrivacyPolicy"
          @change="onInput('acceptPrivacyPolicy', ($event.target as HTMLInputElement).checked)"
        />
        <span v-html="t('contactForm.privacyRequired')"></span>
      </label>
      <div class="cm-error">{{ errors.acceptPrivacyPolicy }}</div>
    </div>

    <div class="cm-field">
      <label class="cm-check">
        <input
          id="cm-marketing"
          name="acceptMarketing"
          type="checkbox"
          :checked="model.acceptMarketing"
          @change="onInput('acceptMarketing', ($event.target as HTMLInputElement).checked)"
        />
        <span>{{ t('contactForm.marketingOptional') }}</span>
      </label>
    </div>
  </form>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  export type StepOneModel = {
    email: string
    acceptPrivacyPolicy: boolean
    acceptMarketing: boolean
  }

  const props = defineProps<{
    model: StepOneModel
    errors: Partial<Record<keyof StepOneModel, string>>
  }>()

  const emit = defineEmits<{
    (e: 'update:model', value: StepOneModel): void
  }>()

  const { t } = useI18n({ useScope: 'global' })

  const onInput = <K extends keyof StepOneModel>(key: K, value: StepOneModel[K]) => {
    emit('update:model', { ...props.model, [key]: value })
  }
</script>
